import React, { FC, useEffect } from "react";
import { GetServerSideProps, GetServerSidePropsContext } from "next";
import { withRouter, useRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Head from "next/head";
import Footer from "../src/components/Footer/Footer";
import Login from "../src/pages/Login/Login";
import { useTheme } from "@mui/material";
import { useColorModeContext } from "../src/contexts/CustomThemeProvider";

interface LoginPageProps extends WithRouterProps {
}

const LoginPage: FC<LoginPageProps> = () => {
    const theme = useTheme()
    const seoTitle = "Login | That's The Ticket";
    const router = useRouter();

    const { setColorMode } = useColorModeContext();

    setColorMode("dark");

    const getRedirectUrl = () => {
        const { redirectURL } = router.query;

        if (redirectURL) {
            window.localStorage.setItem("redirectURL", redirectURL.toString());
        }
    };

    useEffect(() => {
        getRedirectUrl();
    }, []);

    return (

        <>
            <Head>
                <title>{`${seoTitle}`}</title>
                <meta key="ogTitle" property="og:title" content={seoTitle} />
                <meta key="twitterTitle" name="twitter:title" content={seoTitle} />
            </Head>

            <Login />

            <Footer />
        </>

    );
}

export default withRouter(LoginPage);

export const getServerSideProps: GetServerSideProps = async ({ params }: GetServerSidePropsContext) => {

    return {
        props: {}
    }
}